import { create } from "zustand";
import Cookies from "js-cookie";
import { TOKEN_COOKIE_CONFIG } from "../../config";
import { queryClient } from "@/lib/queryClient";

const useAuth = create((set) => ({
  accessToken: Cookies.get("accessToken"),
  refreshToken: Cookies.get("refreshToken"),
  userId: Cookies.get("userId"),
  isAuthenticated: !!Cookies.get("accessToken"),
  userRole: Cookies.get("userRole"),
  userFlow: Cookies.get("userFlow") || null,
  paymentStatus: (() => {
    const status = Cookies.get("paymentStatus");
    // Handle string "null" and convert to actual null
    if (!status || status === "null" || status === "undefined") return null;
    return status;
  })(),

  setTokens: (accessToken, refreshToken, userId) => {
    Cookies.set("accessToken", accessToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("refreshToken", refreshToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("userId", userId, TOKEN_COOKIE_CONFIG);
    set({
      accessToken,
      refreshToken,
      userId,
      isAuthenticated: true,
    });
  },

  setUserRole: (role) => {
    Cookies.set("userRole", role, TOKEN_COOKIE_CONFIG);
    set({ userRole: role });
  },

  setUserFlow: (flow) => {
    Cookies.set("userFlow", flow, TOKEN_COOKIE_CONFIG);
    set({ userFlow: flow });
  },

  setPaymentStatus: (status) => {
    // Don't store null/undefined as strings
    if (status === null || status === undefined) {
      Cookies.remove("paymentStatus");
      set({ paymentStatus: null });
    } else {
      Cookies.set("paymentStatus", status, TOKEN_COOKIE_CONFIG);
      set({ paymentStatus: status });
    }
  },

  clearTokens: () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("userId");
    Cookies.remove("userRole");
    Cookies.remove("userFlow");
    Cookies.remove("paymentStatus");
    
    // Clear React Query cache when clearing tokens
    queryClient.clear();
    
    set({
      accessToken: null,
      refreshToken: null,
      userId: null,
      isAuthenticated: false,
      userRole: null,
      userFlow: null,
      paymentStatus: null,
    });
  },

  updateAccessToken: (newAccessToken) => {
    Cookies.set("accessToken", newAccessToken, TOKEN_COOKIE_CONFIG);
    set({
      accessToken: newAccessToken,
    });
  },
}));

export default useAuth;
